<template>
	<div>
		<div class="row">
			<div class="col-md-8 col-12 mt-2">
				<h3>Suggest Ring</h3>
				<h6>Choose 1 Dealer To Use This Feature</h6>
			</div>
			<div class="col-md-4 col-6 mt-2 wrapHighlight">
				<Multiselect
					:options="filterData.dealer.map((x) => x.code)"
					:custom-label="
						(opt) =>
							filterData.dealer.find((x) => x.code == opt).name
					"
					placeholder="Select 1 Dealer"
					:allow-empty="false"
					v-model="filter.dealer"
				/>
			</div>

			<div v-if="data && geojson && center" class="w-100">
				<!-- {{midPoints}} -->
				<!-- {{geojsonRing1}} -->
				
				<!-- <span>test</span> -->
				<l-map
					:center="center"
					:zoom="zoom"
					ref="map"
					style="min-height:650px;width:100%;z-index:0;position:relative"
				>
					<l-tile-layer
						:url="url"
						:attribution="attribution"
					/>

					<l-circle 
                        v-for="(circle , index) in configRadius"
                        
                        :lat-lng="latLng(center[0] , center[1])"
                        :radius="circle.distance"
                        :fillColor="circle.color"
                        :fillOpacity="0"
                        :color="circle.color"
                        :weight="1"
                    />

					 <l-geo-json
					 	v-if="geojsonOther"
                        :geojson="geojsonOther"
                        :options="options"
                        :options-style="styleFunction('#C39E56')"
                    />
                    <l-geo-json
                        :geojson="geojsonRing1"
                        :options="options"
                        :options-style="styleFunction('#F21C1E')"
                    />
                    <l-geo-json
                        :geojson="geojsonRing2"
                        :options="options"
                        :options-style="styleFunction('#AF73F2')"
                    />
                    <l-geo-json
                        :geojson="geojsonRing3"
                        :options="options"
                        :options-style="styleFunction('#668DAB')"
                    />
                    <l-geo-json
                        :geojson="geojsonLocation"
                        :options="options"
                        :options-style="styleFunction('#CCE85A')"
                    />

					 <l-marker v-for="(data , index) in midPoints" :lat-lng="latLng(data.coordinates[0] , data.coordinates[1])"  :icon="data.icon">
                        <l-icon
                            class="custom-icon"
                        >
                            <div class="headline">
                                <h6 style="color:black">{{ data.value }}</h6>
                                <!-- {{data.value}} -->
                            </div>
                        
                        </l-icon>
                    </l-marker>
				</l-map>
			</div>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

import { latLng , icon , divIcon , map, geoJSON } from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson, LIcon, LPopup, LTooltip, LCircle } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet/dist/leaflet.css"
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
	components: {
        LMap,
        LTileLayer,
        LIcon,
        LGeoJson,
        LMarker,
        LPopup,
        LTooltip,
        LCircle,
		Multiselect
    },
	data () {
		return {
			latLng,
			filter : {
				dealer : null
			},
			filterData : {
				dealer: this.$store.getters.getDealer(null, null),
			},
			data : null,
			geojson : null,
			geojsonOther : null,
            geojsonRing1 : null,
            geojsonRing2 : null,
            geojsonRing3 : null,
            geojsonLocation : null,
			midPoints : null,
			center : null,
			zoom : 11,
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			configRadius : []
		}
	},
	watch : {
		'filter.dealer' : function () {
			if(!this.filter.dealer){
				this.data = null
				return
			}

			this.loadApi()
		}
	},
	computed : {
		options() {
            return {
                onEachFeature: this.onEachFeatureFunction
            };
        },
	},
	async mounted () {
		this.loadMapGeo()

		let arrayColor = ['#B177F2', '#938032' ,'#F21C1E']
		// let curIndex = 0
		for(var i = 0 ; i < arrayColor.length ; i++) {
			let curIndex = i
			let obj = {
				distance : (5 * (i + 1)) * 1000,
				// name : 'Ring ' + (i + 1),
				color : arrayColor[curIndex]
			}

			this.configRadius.push(obj)
			
		}
	},
	methods : {
		async loadMapGeo () {
			const response = await fetch(`https://storage.googleapis.com/mpm-geojson-id/Jawa%20Timur.json`)
			let data = await response.json();
			const response2 = await fetch(`https://storage.googleapis.com/mpm-geojson-id/NTT.json`)
			let data2 = await response2.json();

			// console.log(data.features.find(x => x.id == "ID5371031"))
			// console.log(data2.features.find(x => x.id == "ID5371031"))

			data.features =  data.features.concat(data2.features)
			this.geojson = data
		},
		loadApi () {
			let url = `/api/highlight/map-suggest-ring?dealer=${this.filter.dealer}`

			this.$http.get(url)
			.then((resp) => {
				this.data = resp.data.data

				this.processData()
			})
			.catch((err) => {
				console.log(err)
			})
		},
		processData() {
			let dealerData = this.data.dealer

			if(dealerData && !parseFloat(dealerData.lat) == 0 && !parseFloat(dealerData.lng) == 0)
                this.center = [dealerData.lat , dealerData.lng]
            else
                this.center = ["-7.257621004195039","112.75208164629598"]

			let suggest_ring = this.data.suggest_ring
			console.log(dealerData)

			let otherAreaDealer = suggest_ring.filter(x => x.ring == 'OTHER').map(x => x.kode_kecamatan)
            let ring3Dealer = suggest_ring.filter(x => x.ring == 'RING 3').map(x => x.kode_kecamatan)
            let ring2Dealer = suggest_ring.filter(x => x.ring == 'RING 2').map(x => x.kode_kecamatan)
            let ring1Dealer = suggest_ring.filter(x => x.ring == 'RING 1').map(x => x.kode_kecamatan)
            let locationDealer = suggest_ring.filter(x => x.ring == 'LOKASI').map(x => x.kode_kecamatan)

			let midPoints = []

			this.calculateFeatures('geojsonOther', 'Other' , otherAreaDealer , suggest_ring , midPoints , null)
			this.calculateFeatures('geojsonRing1', 'Ring 1' , ring1Dealer , suggest_ring , midPoints , null)
            this.calculateFeatures('geojsonRing2', 'Ring 2' , ring2Dealer , suggest_ring , midPoints ,null)
            this.calculateFeatures('geojsonRing3', 'Ring 3' , ring3Dealer , suggest_ring , midPoints , null)
            this.calculateFeatures('geojsonLocation', 'Lokasi' , locationDealer , suggest_ring , midPoints , null)


			this.midPoints = midPoints

			
		},
		calculateFeatures(selectedGeojson , typeDealer , areaDealer , dealerData , midPoints , exclusion) {
            let vm = this

            this[selectedGeojson] = {
                type : 'FeatureCollection'
            }
            this[selectedGeojson].features = this.geojson.features.filter(x => areaDealer.includes(x.properties.ADM3_PCODE))
            this[selectedGeojson].features.forEach(async function(e){
                let area = dealerData.find(x => x.kode_kecamatan == e.properties.ADM3_PCODE)
                let pcode = e.properties.ADM3_PCODE
                // e.properties.typeDealer = typeDealer
                // e.properties.total = area.purchase ? area.purchase : area.sales ? area.sales : 0

                if(area.latitude) {
					let value = area.radius

					let obj = {
						coordinates :[area.latitude , area.longitude],
						value : value,
						kecamatan : area.kode_kecamatan,
						// legend : i
					}
					midPoints.push(obj)
				}
                //     vm.dealerRadiusLegend[4].count += area.sales ? area.sales : 0
                //     if(vm.type == 'territorySalesByDocument') {
                //         let value = area.purchase ? area.purchase : area.sales ? area.sales : area.service ? parseInt(area.service) + parseInt(area.service_lost) + parseInt(area.service_service_current_dealer) + parseInt(area.service_service_other_dealer) : 0
                //         let obj = {
                //             coordinates :[area.latitude , area.longitude],
                //             value : value,
                //             kecamatan : area.id_kecamatan,
                //             legend : i
                //         }
                //         midPoints.push(obj)
                //     }
                //     else {
                //         let selectedLegend = vm.type == 'territory' ? vm.purchaseLegend : vm.serviceLegend

                //         let filterCriteria = vm.type == 'territory' ? 'text' : 'compare_text'



                //         for(var i = 0 ; i < selectedLegend.length ; i++) {
                //             let legend = selectedLegend[i]
                //             let value = 0
                //             let points = vm.data.points.filter(x => x.legend.toLowerCase() == legend[filterCriteria].toLowerCase() && x.kecamatan == pcode)

                //             if(exclusion && !exclusion.includes(typeDealer)) {
                //                 value = 0
                //             }
                //             else if(!points || points.length == 0)
                //                 value = 0
                //             else
                //                 value = points.length

                            

                //             let obj = {
                //                 value : value,
                //                 kecamatan : area.id_kecamatan,
                //                 color : legend.color ? legend.color : '#FFF',
                //                 legend : legend[filterCriteria].toLowerCase()
                //             }

                //             for(var j = 10 ; j < 18 ; j++) {
                //                 obj['coordinates' + j] = await vm.addDistanceToMidPoint(area.latitude , area.longitude , i , (1.2 - (0.2 * (j - 10))))
                //             }

                //             midPoints.push(obj)
                //         }
                //     }
                // }
            });
        },
		styleFunction(fillColor) { // important! need touch fillColor in computed for re-calculate when change fillColor
            return () => {
                return {
                    weight: 2,
                    color: "#555",
                    opacity: 0.8,
                    fillColor: fillColor,
                    fillOpacity: 0.36,
                };
            };
        },
	}
}
</script>